import * as React from 'react';
import Item from './Item';
import TableBase from '../../../Employee/Profile/ManagerFor/Table';

export default class Table extends TableBase {

    getTrs() {
        return this.props.units.map((unit: any) => { return (<Item key={unit.id} unit={unit} />); });
    }
}